'use client';
import React, { useEffect } from 'react';
import { TreeNode } from '../NestHeadings';
import { cn } from '@/utils/cn';
import TableOfContentsItem from './TableOfContentsItem';

interface DocsTableContentProps {
  elements: TreeNode[];
  level?: number;
  scrollTitle: string | null;
  setScrollTitle: React.Dispatch<React.SetStateAction<string | null>>;
}

const RenderTableOfContent: React.FC<DocsTableContentProps> = ({
  elements,
  level = 1,
  scrollTitle,
  setScrollTitle
}) => {

  // useEffect(() => {
  //     const handleScroll = () => {
  //         const scrollPosition = window.scrollY;
  //         elements.forEach((el) => {
  //             const section = typeof window !== 'undefined' && typeof document !== "undefined" && document?.getElementById(el.slug);
  //             if (section) {
  //                 const sectionTop = section.offsetTop;
  //                 const sectionHeight = section.offsetHeight;

  //                 if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
  //                     setScrollTitle(el.text);
  //                 }
  //             }
  //         });
  //     };

  //     window.addEventListener('scroll', handleScroll);
  //     return () => {
  //         window.removeEventListener('scroll', handleScroll);
  //     };
  // }, [elements, setScrollTitle]);

  return (
    <ul
      className={cn('space-y-2 text-sm ', {
        'ml-4 list-disc space-y-1 font-normal': level > 1,
        'space-y-3.5': level === 1
      })}
    >
      {elements.map((el) => {
        return (
          <li
            key={el.text}
            className={cn({
              '[&:first-child]:mt-2 ': level > 1
            })}
          >
            <TableOfContentsItem
              item={el}
              scrollTitle={scrollTitle}
              setScrollTitle={setScrollTitle}
            />
            {el.children && (
              <RenderTableOfContent
                elements={el.children}
                level={level + 1}
                scrollTitle={scrollTitle}
                setScrollTitle={setScrollTitle}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default RenderTableOfContent;
